import moment from "moment";

/**
 * BE#657 — normalize a scheduled message's dueDate WITHOUT ever fabricating "now".
 *
 * The early-send bug: an unfinished scheduled draft (no date picked yet) was seeded
 * with `moment(undefined).toDate()` === NOW at several compose entry points (the
 * dialog open in AddScheduledMessageButtonReducer, the composer seed in
 * apply-seed-to-draft, the date picker's default effect). A draft carrying a
 * near-now dueDate is immediately sendable, so if it is persisted before the user's
 * intended FUTURE date is applied, the scheduler fires it days early (and the final
 * future dueDate lands as a later patch — the "message went out on the wrong day"
 * reports). See the gateway changelog / issue #657.
 *
 * This normalizer keeps a VALID date (coerced to a Date so downstream code that does
 * `moment(dueDate)` / `startOf('minute')` is unaffected) and returns `undefined` for
 * an absent or unparseable one — NEVER `now`. An undefined dueDate is correct for an
 * unfinished draft: the compose Send gate already requires an explicit, valid,
 * non-past date (`canSchedule`), so leaving it unset disables Send until the user
 * picks one, instead of silently arming an immediate send.
 */
export function normalizeScheduledDueDate(dueDate: unknown): Date | undefined {
  if (dueDate === undefined || dueDate === null || dueDate === "") return undefined;
  const m = moment(dueDate as moment.MomentInput);
  return m.isValid() ? m.toDate() : undefined;
}
